import React from 'react';

import { apiUrls } from '@constants/apiurls';
import { EmptyCard } from '@components/emptyCard/emptyCard';
import { Button } from '@components/button/button';
import projects from '@redux/modules/projects';
import styles from '@components/dashboard/dashboard.module.scss';
import { routesPath } from '@constants/routesPath';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { ClientHeader } from '@components/clientHeader/clientHeader';
import clients from '@redux/modules/clients';
import { Spinner } from '@components/loader/loader';
import { ContactsListing } from '@components/contactsListing/contactsListing';
import { useEffect } from 'react';
import toast from 'react-hot-toast';

export const ContactsListingContainer = () => {
  // ...existing code...
  const navigate = useNavigate();
  const params = useParams();

  const {
    data: clientData,
    error: clientError,
    isFetching: clientLoading,
  } = clients.list().useClientsdetailQuery(
    { params: { id: params.clientId }, extendedPath: apiUrls.getClientDetail() },
    {
      skip: !params.clientId,
    },
  );

  const [clientUpdate, clientUpdateData] = clients.form().useClientsupdateMutation();

  useEffect(() => {
    if (clientUpdateData?.isSuccess) {
      toast.success('Contact successfully deleted!');
    }
    if (clientUpdateData?.isError) {
      toast.error('Failed to delete contact!');
    }
  }, [clientUpdateData]);

  const onAdd = (contact) => {
    navigate(routesPath.addContacts(params.clientId), { state: { id: contact?.id } });
  };

  const deleteClientContact = (contacts) => {
    let { id } = contacts;
    let contactDetail = {};
    contactDetail['id'] = params?.clientId;
    const previousContacts = clientData.data.client_contacts.map((data) => ({
      id: data.id,
    }));
    const updatedContacts = previousContacts.filter(function (contact) {
      return contact.id != id;
    });
    contactDetail['client_contacts'] = updatedContacts;
    clientUpdate(contactDetail);
  };

  return (
    <div className={styles.dashboardWrappper}>
      {clientLoading ? (
        <div className="text-center ">
          <Spinner height="100" width="100" />
        </div>
      ) : (
        clientData && clientData.data ? (
          Array.isArray(clientData.data.client_contacts) && clientData.data.client_contacts.length > 0 ? (
            <ContactsListing
              clients={clientData.data}
              contacts={clientData.data.client_contacts}
              onProjectAdd={onAdd}
              onRemove={deleteClientContact}
              onEdit={onAdd}
            />
          ) : (
              <div style={{ marginTop: '150px', marginLeft: '30px', display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
              <EmptyCard
                isCard
                title="There are no client contacts available."
                description={`${clientData.data && clientData.data.title ? clientData.data.title : 'Client'} does not have any Client Contacts loaded yet.`}
              >
                <Button
                  submit
                  inline
                  onClick={() => navigate(`/client/${params.clientId}/contacts/add`)}
                >
                  Add Client Contact
                </Button>
              </EmptyCard>
            </div>
          )
        ) : null
      )}
    </div>
  );
};
